import { render } from "./MaterialTabForPo.vue?vue&type=template&id=77201e6a&scoped=true"
import script from "./MaterialTabForPo.vue?vue&type=script&lang=js"
export * from "./MaterialTabForPo.vue?vue&type=script&lang=js"

import "./MaterialTabForPo.vue?vue&type=style&index=0&id=77201e6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77201e6a"]])

export default __exports__